module.exports = __webpack_public_path__ + "static/turtle-creek-house31-d3cdb9855e9096dea54ac77ca81dd453.jpg";